import { AnyAction, combineReducers } from 'redux'
import {
  bootstrapData,
  BootstrapDataState,
  countries,
  countriesStateProps,
  token,
} from './auth'
import {
  calendar,
  CalendarStateType,
  SearchCalendar,
  submitPayment,
  SubmitPayment,
  topBanner,
  TopBannerProps,
  trackerUrl,
  TrackerUrlProps,
  user,
  UserStateProps,
} from './generalReducer'
import {
  homeBanners,
  LateNightStateProps,
  StatisticsState,
  statistics,
  latestBlog,
  LatestBlogState,
  bestRanks,
  BestRanksState,
  aroundHouses,
  heroImage,
  shomalHouses,
  similarHouses,
  selectedCategories,
  SelectedCategoriesProps,
  HomeBannersProps,
  tehranHouses,
  houseReserve,
  type ReservList,
  jonoobHouses,
  HeroImageType,
  boomgardiHouses,
} from './homeReducer'
import {
  product,
  reviews,
  weather,
  proforma,
  pictures,
  reserve,
  ViolationReportType,
  violationReport,
  ProductType,
  productReducer,
  requestToVisit,
} from './productReducers'
import { bookmarkReducer } from './bookmarkReducer'
import {
  ProductStateProps,
  ReviewsState,
  ProformaStateProps,
  WeatherStateProps,
  PicturesStateProps,
  BookmarkStateProps,
  ReserveStateProps,
  BasicFiltersStateProps,
  NPSStateProps,
  invoiceReducerType,
  requestToVisitHouse,
  whiteLabelInvoiceReducerType,
} from '../types'
import {
  SearchStateProps,
  search,
  MainFilters,
  searchFilters,
  basicFilters,
  firstBookingOff,
  PlaceFilter,
  placeFilter,
  firstSearch,
  NeighbourhoodsTypes,
  neighbourhoodsReducer,
} from './searchReducer'
import { nps } from './npsReducer'
import {
  invitationBySMS,
  InvitationBySMS,
  invitationCode,
  InvitationCode,
  invitedList,
  InvitedList,
  reminderReducer,
  ReminderType,
  settelement,
  SettlementType,
  totalGift,
  TotalGift,
} from './referralReducer'
import {
  changePassword,
  ChangePassword,
  discountList,
  DiscountList,
  editUserInfo,
  EditUserInfoType,
  region,
  Region,
  reviewsAboutUser,
  ReviewsAboutUser,
  updateBankAccount,
  UpdateBankAccount,
  uploadPhoto,
  UploadPhoto,
  userInfo,
  UserInfo,
  userReviews,
  UserReviews,
} from './userReducer'
import { ReviewInfoProps, reviewInfo } from './reviewsReducer'
import {
  AllCompanionListType,
  CompanionListType,
  allCompanionList,
  companionList,
  invoiceReducer,
} from './invoiceReducer'
import {
  PushNotificationProps,
  pushNotification,
} from './pushNotificationReducer'
import { ReviewsListProps, reviewsList } from './reviewsListReducer'
import {
  houseList,
  HouseList,
  paymentPhotography,
  PaymentPhotography,
  photographyCost,
  PhotographyCost,
} from './photographyReducer'
import {
  hostCalendarReducer,
  HostCalendarState,
  HostsPanelType,
  hostsReducer,
} from './hostPanelReducer'
import { TripsProps, tripsReducer } from './tripsReducer'
import { CareerProps, careerReducer } from './careerReducer'
import {
  HouseRegisterTypes,
  houseRegisterReducer,
} from './houseRegisterReducer'
import { whiteLabelInvoiceReducer } from './whiteLabelReducer'
import { hotelReducer, HotelState } from './hotelReducer'
import { FlightState, flightReducer } from './flightReducer'

export interface GlobalState {
  heroImage: HeroImageType
  shomalHouses: LateNightStateProps
  jonoobHouses: LateNightStateProps
  tehranHouses: LateNightStateProps
  boomgardiHouses: LateNightStateProps
  houseReserve: ReservList
  homeBanners: HomeBannersProps
  lateNight: LateNightStateProps
  aroundHouses: LateNightStateProps
  search: SearchStateProps
  firstSearch: SearchStateProps
  firstBookingOff: SearchStateProps
  statistics: StatisticsState
  token: string
  latestBlog: LatestBlogState
  countries: countriesStateProps
  bestRanks: BestRanksState
  calendarData: CalendarStateType
  searchCalendar: CalendarStateType
  reviews: ReviewsState
  product: ProductStateProps
  similarHouses: LateNightStateProps
  user: UserStateProps
  searchFilters: MainFilters
  weather: WeatherStateProps
  proforma: ProformaStateProps
  topBanner: TopBannerProps
  trackerUrl: TrackerUrlProps
  selectedCategories: SelectedCategoriesProps
  bootstrapData: BootstrapDataState
  pictures: PicturesStateProps
  bookmarkReducer: BookmarkStateProps
  reserve: ReserveStateProps
  basicFilters: BasicFiltersStateProps
  nps: NPSStateProps
  placeFilter: PlaceFilter
  neighbourhoodsReducer: NeighbourhoodsTypes
  invitationCode: InvitationCode
  invitationBySMS: InvitationBySMS
  invitedList: InvitedList
  settelement: SettlementType
  totalGift: TotalGift
  reminder: ReminderType
  userInfo: UserInfo
  editUserInfo: EditUserInfoType
  region: Region
  discountList: DiscountList
  changePassword: ChangePassword
  updateBankAccount: UpdateBankAccount
  userReviews: UserReviews
  reviewsAboutUser: ReviewsAboutUser
  uploadPhoto: UploadPhoto
  isIran: boolean
  violationReport: ViolationReportType
  reviewInfo: ReviewInfoProps
  requestToVisit: requestToVisitHouse
  pushNotification: PushNotificationProps
  submitPayment: SubmitPayment
  reviewsList: ReviewsListProps
  photographyCost: PhotographyCost
  houseList: HouseList
  paymentPhotography: PaymentPhotography
  invoiceReducer: invoiceReducerType
  companionList: CompanionListType
  allCompanionList: AllCompanionListType
  hostsReducer: HostsPanelType
  hostCalendarData: HostCalendarState
  productReducer: ProductType
  tripsReducer: TripsProps
  career: CareerProps
  houseRegisterReducer: HouseRegisterTypes
  whiteLabelInvoiceReducer: whiteLabelInvoiceReducerType
  hotel: HotelState
  flight: FlightState
}

const combine = combineReducers({
  heroImage,
  homeBanners,
  search,
  firstSearch,
  firstBookingOff,
  statistics,
  latestBlog,
  countries,
  bestRanks,
  aroundHouses,
  shomalHouses,
  jonoobHouses,
  houseReserve,
  tehranHouses,
  boomgardiHouses,
  calendarData: calendar,
  SearchCalendar,
  reviews,
  product,
  similarHouses,
  user,
  searchFilters,
  weather,
  proforma,
  topBanner,
  trackerUrl,
  selectedCategories,
  token,
  bootstrapData,
  pictures,
  bookmarkReducer,
  reserve,
  basicFilters,
  nps,
  placeFilter,
  neighbourhoodsReducer,
  invitationCode,
  invitationBySMS,
  invitedList,
  settelement,
  totalGift,
  reminder: reminderReducer,
  userInfo,
  editUserInfo,
  region,
  discountList,
  changePassword,
  updateBankAccount,
  userReviews,
  reviewsAboutUser,
  uploadPhoto,
  violationReport,
  requestToVisit,
  reviewInfo,
  pushNotification,
  submitPayment,
  reviewsList,
  photographyCost,
  houseList,
  paymentPhotography,
  invoiceReducer,
  whiteLabelInvoiceReducer,
  companionList,
  allCompanionList,
  hostsReducer,
  hostCalendarData: hostCalendarReducer,
  productReducer,
  tripsReducer,
  career: careerReducer,
  houseRegisterReducer,
  hotel: hotelReducer,
  flight: flightReducer,
})

const rootReducer = (state: any, action: AnyAction) => {
  return combine(state, action as any)
}

export default rootReducer
